import React, { useState } from 'react'
import logo from '../images/koshlogo.png'
import appInfo1 from '../images/appInfo1.png'
import appInfo2 from '../images/appInfo2.png'
import appInfo3 from '../images/appInfo3.png'
import appInfo4 from '../images/appInfo4.png'
import appInfo5 from '../images/appInfo5.png'
import MediaGallery from './media/MediaGallery'
import DataSafety from './DataSaftey/DataSaftey'
import './textStyle.css'
import About from './About/About'
import { Icon } from '@dashboard/common/src/component/Component'
import DownloadButton from './DownloadApp/DownloadButton'
import Reviews from './Reviews/Reviews'
import Steps from './installSteps/steps'
const images = [
    { src: appInfo1, alt: 'App Info' },
    { src: appInfo2, alt: 'App Info' },
    { src: appInfo3, alt: 'App Info' },
    { src: appInfo4, alt: 'App Info' },
    { src: appInfo5, alt: 'App Info' }
]
const videos = [
    { src: 'https://www.youtube.com/embed/PDVBYZ3yllU' }
]
const Main = () => {
    const [downloaded, setDownloaded] = useState(false)
    const [dialogOpen, setDialogOpen] = useState(false)
    const stats = ({ first, second, third }) => {
        return (<>
            <div style={{ display: 'flex', width: '44vw', flexDirection: 'column', gap: 8 }}>
                <span style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                    {
                        (first == 'icon') ?
                            <Icon className="icon ni ni-arrow-to-down"></Icon> :
                            first
                    }
                </span>
                <span style={{ fontSize: 12, textAlign: 'center' }}>{second}</span>
            </div>
            {!third && <span>|</span>}
        </>
        )
    }
    return (
        <div style={{ display: dialogOpen ? 'none' : '', padding: 16, width: '99vw', fontFamily: 'arial,sans-serif', fontSize: 17, }}>
            <div style={{
                display: 'flex', border: '0px solid green', gap: 18,
            }}>
                <div style={{ width: 80, height: 80, border: '0px solid blue', borderRadius: 10 }}>
                    <img style={{ width: '100%', borderRadius: 10 }} src={logo} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 5 }}>
                    <span style={{ fontSize: 22, fontWeight: 'bolder', color: 'black' }}>Kosh - Loan App</span>
                    <span style={{ fontWeight: '400', letterSpacing: 0.4, color: '#01875f' }}>Adhikosh Financial Advisory</span>
                </div>
            </div>
            <div style={{ display: 'flex', width: '95%', overflowX: 'auto', 
                justifyContent: 'space-between', padding: 10, marginBottom: 10, marginTop: 10
            }}>
                {stats({ first: '4.4 ★', second: '38.8K reviews' })}
                {stats({ first: 'icon', second: '87 MB' })}
                {stats({ first: '500K+', second: 'Downloads' })}
                {stats({ first: '3+', second: 'Rated for 3+', third: 'last' })}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 3 }}>
                <DownloadButton downloaded={downloaded} setDownloaded={setDownloaded} />
            </div>

            {downloaded ? <Steps downloaded={downloaded} setDownloaded={setDownloaded} /> :
                <>
                    <MediaGallery
                        videos={videos}
                        images={images}
                    />
                    <About setDialogOpen={setDialogOpen} />
                    <DataSafety setDialogOpen={setDialogOpen} />
                    <Reviews setDialogOpen={setDialogOpen} />
                </>
            }
        </div>
    )
}
export default Main
